// Cart Page AJAX Implementation
document.addEventListener('DOMContentLoaded', function() {
  // Initialize cart functionality
  initCartPageFunctionality();
  
  // Add event listeners to "Add to basket" buttons in recommended products
  initAddToCartButtons();
  
  // Initialize gift buttons state if they exist
  if (document.querySelector('.add-gift-btn')) {
    updateGiftButtons();
  }
});

// Free Gift Functions
function addFreeGift(button) {
  const productId = button.getAttribute('data-product-id');
  const variantId = button.getAttribute('data-variant-id');

  // Check if we've reached the maximum free gifts
  const maxFreeGifts = parseInt(document.getElementById('max-free-gifts') ? document.getElementById('max-free-gifts').value : 1);
  const currentFreeGifts = countFreeGiftsInCart();
  
  if (currentFreeGifts >= maxFreeGifts) {
    button.disabled = true;
    button.textContent = 'Limit reached';
    return;
  }
  
  // Disable the button to prevent multiple clicks
  button.disabled = true;
  button.textContent = 'Adding...';
  
  // Add the free gift to cart with price 0
  fetch('/cart/add.js', {         
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      properties: {
        '_free_gift': 'true'
      }
    })
  })
  .then(response => response.json())
  .then(data => {
    // Update button text
    button.textContent = 'Added!';
    
    // Get the free gift section
    const freeGiftSlider = document.querySelector('.free-gift-slider');
    
    // Play confetti animation
    if (window.cartConfetti) {
      window.cartConfetti.play();
      
      // Update cart immediately - don't wait for animation to complete
      setTimeout(()=>{
        updateCart();
        // Hide the free gift section when gift is added to cart
        if (freeGiftSlider) {
          freeGiftSlider.style.display = 'none';
        }
      }, 1400)
    }
  })
  .catch(error => {
    console.error('Error:', error);
    button.disabled = false;
    const addGiftText = document.getElementById('add-gift-text') ? document.getElementById('add-gift-text').value : 'Add to cart';
    button.textContent = addGiftText;
  });
}

// Check how many free gifts are already in the cart
function countFreeGiftsInCart() {
  let count = 0;
  
  // If we have cart data in a global variable, use it
  if (window.cartData && window.cartData.items) {
    window.cartData.items.forEach(item => {
      if (item.properties && item.properties._free_gift) {
        count++;
      }
    });
    return count;
  }
  
  // Otherwise, check the DOM for items with the free gift property
  const freeGiftItems = document.querySelectorAll('.elem[data-free-gift="true"]');
  return freeGiftItems.length;
}

// Update gift buttons based on free gift count
function updateGiftButtons() {
  const maxFreeGiftsEl = document.getElementById('max-free-gifts');
  if (!maxFreeGiftsEl) return;
  
  const maxFreeGifts = parseInt(maxFreeGiftsEl.value);
  const currentFreeGifts = countFreeGiftsInCart();
  const remainingGifts = maxFreeGifts - currentFreeGifts;
  
  const giftButtons = document.querySelectorAll('.add-gift-btn');
  if (giftButtons.length === 0) return;
  
  if (remainingGifts <= 0) {
    // Disable all gift buttons if max is reached
    giftButtons.forEach(button => {
      button.disabled = true;
      button.textContent = 'Limit reached';
    });
  } else {
    // Update button text to show remaining gifts
    giftButtons.forEach(button => {
      if (!button.disabled || button.textContent === 'Limit reached') {
        const addGiftText = document.getElementById('add-gift-text') ? document.getElementById('add-gift-text').value : 'Add to cart';
        button.textContent = addGiftText;
        button.disabled = false;
      }
    });
    
    // Update count message
    const countEl = document.querySelector('.free-gift-count');
    if (countEl && maxFreeGifts > 1) {
      countEl.textContent = '(' + remainingGifts + ' of ' + maxFreeGifts + ' available)';
    }
  }
}

// Function to automatically add the first available free gift
function autoAddFreeGift() {
  // Add a 1-second delay before adding the free gift to the cart
  // This ensures the free gift is added at the perfect moment
  setTimeout(() => {
    // Check if we've reached the maximum free gifts
    const maxFreeGifts = parseInt(document.getElementById('max-free-gifts') ? document.getElementById('max-free-gifts').value : 1);
    const currentFreeGifts = countFreeGiftsInCart();
    
    if (currentFreeGifts >= maxFreeGifts) {
      console.log('Maximum free gifts already added');
      return;
    }
    
    // Find the first available free gift button
    const giftButton = document.querySelector('.add-gift-btn:not([disabled])');
    if (giftButton) {
      // Get product and variant IDs
      const productId = giftButton.getAttribute('data-product-id');
      const variantId = giftButton.getAttribute('data-variant-id');
      
      if (!variantId) {
        console.error('No variant ID found for free gift');
        return;
      }
      
      // Add the free gift to cart with price 0
      fetch('/cart/add.js', {         
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: {
            '_free_gift': 'true',
            '_auto_added': 'true'
          }
        })
      })
      .then(response => response.json())
      .then(data => {
        // Update button text
        giftButton.textContent = 'Added!';
        giftButton.disabled = true;
        
        console.log('Auto-added free gift:', data.title);
        
        // Play confetti animation when free gift is added
        if (window.cartConfetti) {
          window.cartConfetti.play();
          
          // Update cart after confetti animation
          setTimeout(() => {
            updateCart();
          }, 1400);
        } else {
          // If confetti is not available, just update the cart
          updateCart();
        }
      })
      .catch(error => {
        console.error('Error auto-adding free gift:', error);
      });
    } else {
      console.log('No available free gift buttons found');
    }
  }, 1000); // 1-second delay as requested
}

function initCartPageFunctionality() {
  // Update quantity selects in the cart page
  initQuantityChanges();
  
  // Initialize remove item buttons
  initRemoveButtons();
}

function initAddToCartButtons() {
  // Find all Add to basket buttons in the recommended products section
  const addToCartButtons = document.querySelectorAll('.products__box--wrapper .basket');
  
  addToCartButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      
      let variantId;
      
      if (this.dataset.variantId) {
        variantId = this.dataset.variantId;
      } else {
        // Extract variant ID from URL if it's a direct link
        const url = new URL(this.href, window.location.origin);
        const urlParams = new URLSearchParams(url.search);
        variantId = urlParams.get('id');
      }
      
      if (!variantId) {
        console.error('No variant ID found for add to cart');
        return;
      }
      
      // Add the item to the cart
      addToCart(variantId, 1);
    });
  });
}

function addToCart(variantId, quantity) {
  // Show loading state
  document.body.classList.add('cart-loading');
  
  // Add item to cart using Shopify's Cart API
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity
    })
  })
  .then(response => response.json())
  .then(data => {
    // Successfully added item, now update the cart
    
    // Check if we should play confetti and add free gift
    fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(response => response.json())
    .then(cart => {
      // Get the gift threshold from the hidden input
      const thresholdInput = document.getElementById('gift-threshold');
      if (!thresholdInput || thresholdInput.dataset.enabled !== 'true') {
        updateCart(); // No free gift feature or not enabled
        return;
      }
      
      const threshold = parseInt(thresholdInput.value, 10);
      const cartTotal = cart.total_price;
      const currentFreeGifts = countFreeGiftsInCart();
      
      // Check if cart is eligible for a free gift:
      // 1. Cart total is above threshold
      // 2. No free gifts have been added yet
      // 3. The added item is not a free gift itself
      if (cartTotal >= threshold && currentFreeGifts === 0 && !data.properties?._free_gift) {
        console.log('Cart eligible for free gift - Cart total:', cartTotal, 'Threshold:', threshold);
        
        // Update the progress bar to show eligibility for free gift
        // but don't add the free gift automatically
        updateProgressBar(cart);
      }
      
      updateCart();
    })
    .catch(error => {
      console.error('Error checking cart for free gift eligibility:', error);
      updateCart();
    });
  })
  .catch(error => {
    console.error('Error adding item to cart:', error);
    document.body.classList.remove('cart-loading');
  });
}

function updateCart() {
  // Fetch the updated cart data
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Accept': 'application/json'
    }
  })
  .then(response => response.json())
  .then(cart => {
    // Store cart data globally for reference
    window.cartData = cart;
    
    // Update cart count
    updateCartCount(cart.item_count);
    
    // Check if we need to remove free gifts
    checkAndRemoveFreeGifts(cart)
      .then(() => {
        // Check if confetti animation is running
        if (window.cartConfetti && window.cartConfetti.animationRunning) {
          // Wait for confetti animation to complete before reloading
          setTimeout(() => {
            window.location.reload();
          }, 500); // Animation duration (2000ms) + small buffer
        } else {
          // Reload cart content immediately if no confetti is playing
          window.location.reload();
        }
      });
  })
  .catch(error => {
    console.error('Error fetching cart:', error);
    document.body.classList.remove('cart-loading');
  });
}

function checkAndRemoveFreeGifts(cart) {
  // Get the gift threshold from the hidden input
  const thresholdInput = document.getElementById('gift-threshold');
  if (!thresholdInput || thresholdInput.dataset.enabled !== 'true') {
    console.log('Free gift feature not enabled or threshold input not found');
    return Promise.resolve(); // No free gift feature or not enabled
  }
  
  const threshold = parseInt(thresholdInput.value, 10);
  const cartTotal = cart.total_price;
  
  console.log('Checking free gifts - Cart Total:', cartTotal, 'Threshold:', threshold);
  
  // If cart total is below threshold, check for free gifts to remove
  if (cartTotal < threshold) {
    console.log('Cart total is below threshold, checking for free gifts to remove');
    
    // Create an updates object for the cart
    const updates = {};
    let hasFreeGifts = false;
    let freeGiftCount = 0;
    
    // Find all free gift items in the cart and set their quantity to 0
    cart.items.forEach(item => {
      if (item.properties && item.properties._free_gift) {
        console.log('Found free gift item:', item.title, 'with key:', item.key);
        updates[item.key] = 0; // Set quantity to 0 to remove
        hasFreeGifts = true;
        freeGiftCount++;
      }
    });
    
    console.log('Found', freeGiftCount, 'free gift items to remove');
    
    // If there are free gifts, remove them all at once
    if (hasFreeGifts) {
      console.log('Removing free gifts with updates:', updates);
      
      return new Promise((resolve) => {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ updates })
        })
        .then(response => {
          console.log('Free gift removal response status:', response.status);
          return response.json();
        })
        .then(updatedCart => {
          console.log('Free gifts removed successfully, updated cart:', updatedCart);
          
          // Force a page reload after removing free gifts to update the UI
          window.location.reload();
          
          // This resolve will never be reached due to the page reload,
          // but we include it for completeness
          resolve();
        })
        .catch(error => {
          console.error('Error removing free gifts:', error);
          resolve(); // Resolve even on error to continue the flow
        });
      });
    }
  } else {
    console.log('Cart total is above threshold, no need to remove free gifts');
  }
  
  return Promise.resolve();
}

function updateCartCount(count) {
  // Update the cart count in the header
  const cartCountElements = document.querySelectorAll('.cart__open span');
  cartCountElements.forEach(element => {
    element.textContent = count;
  });
}

function initQuantityChanges() {
  // Find all quantity selects in the cart page
  const quantitySelects = document.querySelectorAll('.cart__page .quantity-input');
  
  quantitySelects.forEach(select => {
    // Remove existing event listeners
    const newSelect = select.cloneNode(true);
    select.parentNode.replaceChild(newSelect, select);
    
    // Add new event listener
    newSelect.addEventListener('change', function() {
      const newQuantity = parseInt(this.value, 10);
      const line = parseInt(this.dataset.line, 10);
      
      updateItemQuantity(line, newQuantity);
    });
  });
}

function updateItemQuantity(line, quantity) {
  // Show loading state
  document.body.classList.add('cart-loading');
  
  // Update the item quantity
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      line: line,
      quantity: quantity
    })
  })
  .then(response => response.json())
  .then(cart => {
    // Store cart data globally for reference
    window.cartData = cart;
    
    // Update cart count
    updateCartCount(cart.item_count);
    
    // Check if we need to remove or add free gifts
    const thresholdInput = document.getElementById('gift-threshold');
    if (thresholdInput && thresholdInput.dataset.enabled === 'true') {
      const threshold = parseInt(thresholdInput.value, 10);
      const cartTotal = cart.total_price;
      const currentFreeGifts = countFreeGiftsInCart();
      
      // If cart total is now above threshold and we don't have free gifts, update the UI
      if (cartTotal >= threshold && currentFreeGifts === 0) {
        // If we're not removing an item (quantity > 0), update the UI
        if (quantity > 0) {
          console.log('Cart total now above threshold, showing free gift options');
          
          // Update cart subtotal and line item prices
          updateCartTotals(cart);
          
          // Remove loading state
          document.body.classList.remove('cart-loading');
          
          // Reload the page to show the free gift options
          window.location.reload();
          
          // Return early to prevent the code below from executing
          return;
        }
      }
      
      // Check if we need to remove free gifts
      checkAndRemoveFreeGifts(cart)
        .then(() => {
          // Update cart subtotal and line item prices
          updateCartTotals(cart);
          
          // Remove loading state
          document.body.classList.remove('cart-loading');
          
          // If quantity is 0 or cart is empty, reload the page
          if (quantity === 0 || cart.item_count === 0) {
            window.location.reload();
          }
        });
    } else {
      // Update cart subtotal and line item prices
      updateCartTotals(cart);
      
      // Remove loading state
      document.body.classList.remove('cart-loading');
      
      // If quantity is 0 or cart is empty, reload the page
      if (quantity === 0 || cart.item_count === 0) {
        window.location.reload();
      }
    }
  })
  .catch(error => {
    console.error('Error updating item quantity:', error);
    document.body.classList.remove('cart-loading');
  });
}

function updateCartTotals(cart) {
  // Update subtotal
  const subtotalElements = document.querySelectorAll('.table__result .top .row:first-child p');
  subtotalElements.forEach(element => {
    element.textContent = formatMoney(cart.items_subtotal_price);
  });
  
  // Update total
  const totalElements = document.querySelectorAll('.table__result .bottom p, .final__checkout p');
  totalElements.forEach(element => {
    element.textContent = formatMoney(cart.total_price);
  });
  
  // Update line item prices
  cart.items.forEach((item, index) => {
    const priceElement = document.querySelectorAll('.cart__page .list .elem .desc .bottom p')[index];
    if (priceElement) {
      priceElement.textContent = formatMoney(item.final_line_price);
    }
  });
  
  // Update shipping message based on threshold
  const shippingThreshold = parseFloat(document.querySelector('.cart__page').dataset.freeShippingThreshold || 100);
  
  // Get all rows and find the shipping row specifically by its label text
  const rows = document.querySelectorAll('.table__result .top .row');
  let shippingMessageElement = null;
  
  rows.forEach(row => {
    const label = row.querySelector('span');
    if (label && label.textContent.includes('Shipping')) {
      shippingMessageElement = row.querySelector('p');
    }
  });
  
  if (shippingMessageElement) {
    const cartTotalDollars = cart.total_price / 100;
    console.log('Cart total: $' + cartTotalDollars + ', Threshold: $' + shippingThreshold);
    
    if (cartTotalDollars >= shippingThreshold) {
      shippingMessageElement.textContent = 'FREE';
    } else {
      shippingMessageElement.textContent = 'Calculated at checkout';
    }
  } else {
    console.error('Shipping message element not found');
  }
  
  // Update progress bar
  updateProgressBar(cart);
}

// Function to update the progress bar
function updateProgressBar(cart) {
  const progressBarContainer = document.getElementById('progress-bar-container');
  if (!progressBarContainer) return;
  
  const thresholdInput = document.getElementById('gift-threshold');
  if (!thresholdInput || thresholdInput.getAttribute('data-enabled') !== 'true') return;
  
  const threshold = parseInt(thresholdInput.value, 10);
  const cartTotal = cart.total_price;
  
  // Calculate progress percentage
  const progressPercentage = Math.min((cartTotal / threshold) * 100, 100);
  
  // Update progress bar width
  const progressBar = progressBarContainer.querySelector('.progress-bar');
  if (progressBar) {
    progressBar.style.width = progressPercentage + '%';
  }
  
  // Update progress message
  const progressMessage = progressBarContainer.querySelector('.progress-message p');
  if (progressMessage) {
    if (cartTotal >= threshold) {
      // Get the threshold reached message from the data attribute
      const thresholdReachedMessage = progressMessage.getAttribute('data-threshold-reached-message') || "You've qualified for a free gift!";
      progressMessage.textContent = thresholdReachedMessage;
    } else {
      const remainingAmount = threshold - cartTotal;
      const formattedAmount = formatMoney(remainingAmount);
      // Get the progress message template from the data attribute
      const progressMessageTemplate = progressMessage.getAttribute('data-progress-message') || "Add [amount] to get a free gift";
      progressMessage.textContent = progressMessageTemplate.replace('[amount]', formattedAmount);
    }
  }
  
  // Show/hide free gift section based on threshold
  const freeGiftSection = document.querySelector('.free-gift-section');
  if (freeGiftSection) {
    if (cartTotal >= threshold) {
      //freeGiftSection.style.display = 'block';
    } else {
      freeGiftSection.style.display = 'none';
    }
  }
}

function initRemoveButtons() {
  // Find all remove buttons in the cart page
  const removeButtons = document.querySelectorAll('.cart__page .cart-remove');
  
  // Get all cart items to determine line numbers
  const cartItems = document.querySelectorAll('.cart__page .list .elem');
  
  removeButtons.forEach((button, index) => {
    // Remove existing event listeners
    const newButton = button.cloneNode(true);
    button.parentNode.replaceChild(newButton, button);
    
    // Add new event listener
    newButton.addEventListener('click', function(event) {
      event.preventDefault();
      
      // Get the line number based on the item's position in the cart
      // Line numbers in Shopify are 1-based, so add 1 to the index
      const line = index + 1;
      
      console.log('Removing item at line:', line);
      updateItemQuantity(line, 0);
    });
  });
}

// Helper function to format money
function formatMoney(cents) {
  const formatOptions = {
    style: 'currency',
    currency: Shopify.currency.active || 'USD'
  };
  
  return (cents / 100).toLocaleString(undefined, formatOptions);
}
